import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  fr: {
    translation: {
      nav: {
        home: "Accueil",
        team: "Équipe",
        chapter: "Chapters",
        tv: "Acefund TV",
        faq: "FAQ",
      },
      hero: {
        welcome: "Bienvenue chez",
        subtitle_part1: "LA PLATEFORME",
        subtitle_part2: "QUI TOKENISE LES AVANCES SUR LES REVENUS",
        q1_title: "QU’EST-CE QU'UNE AVANCE SUR REVENUS ?",
        q1_text1_start: "Ce modèle appelé",
        q1_text1_span: "« Revenue based financing »",
        q1_text1_end:
          "permet aux entreprises d’obtenir une avance sur les revenus qu’elles vont générer dans le futur.",
        q1_text2:
          "C’est en fait une avance de trésorerie qui débloque du capital de croissance non dilutif. En échange, les financeurs reçoivent un pourcentage du chiffre d’affaires de l’entreprise sur une période définie.",
        q2_title: "QU'EST CE QUE LA TOKENISATION ?",
        q2_text1:
          "La tokenization est la digitalisation des titres financiers sur un registre blockchain. Chaque titre est représenté numériquement par un token.",
        q2_text2:
          "Ce registre est consultable par tous pour plus de transparence et apporte également plus de liquidité car les tokens sont fongibles et plus facilement transférables à de potentiels acquéreurs.",
        anim_static: "Ce procédé est",
        anim_words: ["RAPIDE", "PEU COÛTEUX", "IMMUABLE"],
        anim_subtext:
          "Notre technologie permet également la tokénisation d’actifs comme le private equity, l’immobilier, les ICO.",
      },
      chapter: {
        title: "NOS CHAPTERS",
        subtitle: "Rejoignez la communauté AceFund près de chez vous",
      },
      rocket: {
        title_start: "VOUS SOUHAITEZ ÊTRE",
        title_end: "ACCOMPAGNÉ POUR :",
        f1_text1: "Lancer une",
        f1_high1: "ICO",
        f1_text2: "ou une",
        f1_high2: "STO",
        f2_text: "Financer votre",
        f2_high: "projet",
        f3_text: "Solution en",
        f3_high: "marque blanche",
        f4_text: "Créer votre",
        f4_high: "marketplace",
        f5_text: "Devenir",
        f5_high: "investisseur",
        cta: "CONTACTEZ-NOUS",
      },
      services: {
        subtitle_start: "PLUS QU'UN",
        subtitle_span: "SERVICE",
        card1_start: "ACE Fund c'est une",
        card1_span: "technologie",
        card1_end: "et une plateforme unique.",
        card2_start: "ACE Fund c'est un",
        card2_span: "réseau international",
        card2_end: "d'entrepreneurs et d'investisseurs.",
        card3_start: "ACE Fund c'est aussi un",
        card3_span: "club",
        card3_end: " d'investissement privé et innovant.",
      },
      cta_section: {
        button: "Rejoindre le Club ACE Fund",
      },
      testimonials_section: {
        title: "NOS TÉMOIGNAGES",
      },
      partners_section: {
        title: "NOS PARTENAIRES",
        subtitle: "PREMIUM",
      },
      group: {
        title: "Le groupe ACE Good",
        desc: "ACE Good développe des solutions innovantes basées sur la blockchain.",
        oneticket_desc:
          "OneTicket transforme chaque billet en un outil infalsifiable, intelligent et générateur de revenus — sans changer les habitudes des spectateurs.",
        acefund_desc:
          "ACE Fund est une solution développé par la compagnie ACE Good.",
      },
      team_section: {
        title: "NOTRE",
        title_span: "ÉQUIPE",
        subtitle: "Les experts derrière la révolution AceFund",
        greg_desc:
          "Entrepreneur passionné par l’innovation, la culture et la blockchain",
        alicya_desc:
          "COO d’ACE Good, je pilote la structuration et la croissance d’une plateforme pionnière de tokenisation d’actifs réels.",
        paul_desc:
          "J'allie expertise technique et vision produit pour bâtir les outils d'investissement de demain.",
      },
      contact: {
        title: "CONTACTEZ-NOUS",
        subtitle: "POUR PLUS D'INFORMATIONS",
        label_name: "Nom*",
        label_firstname: "Prénom*",
        label_email: "Email*",
        label_message: "Message*",
        placeholder_name: "Votre nom",
        placeholder_firstname: "Votre prénom",
        placeholder_email: "exemple@email.com",
        placeholder_message: "Comment pouvons-nous vous aider ?",
        btn_send: "ENVOYER",
        btn_sending: "Envoi en cours...",
        success_title: "Message envoyé !",
        success_text:
          "Merci, l'équipe AceFund vous répondra sur hello@acefund.io très vite.",
        btn_reset: "Envoyer un autre message",
        error_alert: "Une erreur est survenue, veuillez réessayer.",
      },
      faq: {
        title: "Foire aux Questions",
        subtitle: "Tout ce que vous devez savoir sur le Club ACE Fund",
        search_placeholder: "Rechercher une question...",
        items: [
          {
            id: 1,
            category: "Généralités",
            question: "Qu’est-ce que le Club ACE Fund ?",
            answer:
              "ACE Fund est un club d’investisseurs privé qui propose à ses membres des opportunités d’investissement diversifiées (immobilier, crypto, cinéma, etc.), accompagnées d’un réseau d’experts et d’événements exclusifs.",
          },
          {
            id: 2,
            category: "Adhésion",
            question:
              "Qui peut rejoindre le Club ACE Fund ? Y a-t-il des critères d’admission ?",
            answer:
              "Le club est ouvert à toute personne majeure, qu’elle soit novice ou experte en investissement. Aucune compétence technique n’est requise.",
          },
          {
            id: 3,
            category: "Avantages",
            question: "Quels sont les avantages à devenir membre du club ?",
            answer:
              "Accès à des opportunités exclusives, événements, accompagnement personnalisé, système de parrainage et avantages VIP.",
          },
          {
            id: 4,
            category: "Inscription",
            question: "Comment adhérer au club ?",
            answer:
              "L’adhésion se fait en ligne via notre site. Remplissez le formulaire, choisissez votre niveau et réglez les frais.",
          },
          {
            id: 5,
            category: "Tarifs",
            question: "Quel est le coût de l’adhésion ?",
            answer:
              "Nous proposons plusieurs formules (Investor, Industry, Business Circle, Private). Les détails sont sur la page Adhésions.",
          },
          {
            id: 8,
            category: "Fonctionnement",
            question: "Comment le club sélectionne-t-il les opportunités ?",
            answer:
              "Nos experts analysent les projets (financiers, juristes). Nous privilégions l'innovation et le rendement élevé.",
          },
          {
            id: 11,
            category: "Fonctionnement",
            question: "Existe-t-il des chapters locaux ?",
            answer:
              "Oui (Bordeaux, Martinique, Paris...). Contactez-nous pour en rejoindre un ou en créer un.",
          },
          {
            id: 19,
            category: "Parrainage",
            question: "Comment fonctionne le parrainage ?",
            answer:
              "Vous touchez une commission sur chaque adhésion réalisée via votre lien unique : 15 % sur Investor, 25 % sur Business Circle et 50 % sur Private.",
          },
          {
            id: 22,
            category: "Investissement",
            question: "Quels types d’opportunités proposez-vous ?",
            answer: "Immobilier, cinéma, crypto, et autres secteurs innovants.",
          },
          {
            id: 32,
            category: "Blockchain",
            question: "Qu’est-ce que la blockchain ?",
            answer:
              "Une technologie de stockage transparente et sécurisée permettant des transactions infalsifiables.",
          },
          {
            id: 37,
            category: "Tokenisation",
            question: "Qu’est-ce que la tokenisation ?",
            answer:
              "Diviser un actif en tokens numériques pour permettre l'investissement fractionné.",
          },
          {
            id: 38,
            category: "Tokenisation",
            question: "Quels sont les avantages de la tokenisation ?",
            answer:
              "L'investissement est fractionné et accessible, la liquidité est accrue (revente possible) et la traçabilité des transactions est totale.",
          },
          {
            id: 39,
            category: "Tokenisation",
            question: "Comment acheter, vendre ou échanger des tokens ?",
            answer:
              "Les tokens s’achètent via notre plateforme ou des exchanges partenaires. Pour les vendre, vous pouvez les proposer sur notre marketplace ou les échanger contre d’autres tokens.",
          },
          {
            id: 40,
            category: "Tokenisation",
            question: "Où sont stockés mes tokens ? Ai-je besoin d’un wallet ?",
            answer:
              "Non, vous aurez un wallet créé automatiquement depuis votre adresse email. Il sera stocké sur la blockchain et disponible depuis notre plateforme ACE Fund.",
          },
          {
            id: 41,
            category: "Tokenisation",
            question: "Qu’est-ce qu’un smart contract ?",
            answer:
              "Un smart contract est un programme automatique qui exécute les termes d’un contrat (ex: versement de dividendes) sans intermédiaire. Il est stocké sur la blockchain et ne peut être modifié.",
          },
          {
            id: 42,
            category: "Tokenisation",
            question: "La tokenisation est-elle réglementée ?",
            answer:
              "Oui, les projets tokenisés doivent respecter les réglementations en vigueur (AMF en France, SEC aux USA). Nous travaillons avec des avocats spécialisés pour garantir la conformité.",
          },
          {
            id: 43,
            category: "Risques",
            question:
              "Quels sont les risques liés aux investissements tokenisés ?",
            answer:
              "Les risques sont égaux aux investissements traditionnels. Notre thèse de sécurité est conforme aux exigences de cybersécurité exigées par l’État français.",
          },
          {
            id: 44,
            category: "Risques",
            question: "Comment garantissez-vous la transparence ?",
            answer:
              "Tous les projets sont audités et les transactions sont enregistrées sur la blockchain, consultables par tous. Nous publions aussi des rapports réguliers.",
          },
          {
            id: 45,
            category: "Risques",
            question: "Puis-je perdre la totalité de mon investissement ?",
            answer:
              "Comme tout investissement, il existe un risque de perte. Nous sélectionnons des projets solides, mais nous recommandons toujours de diversifier vos placements.",
          },
          {
            id: 46,
            category: "Technique",
            question: "Comment puis-je payer et échanger mes tokens ?",
            answer:
              "Vous vous connectez sur la plateforme et vous échangez facilement vos tokens. Votre wallet est relié directement à votre boîte email.",
          },
          {
            id: 47,
            category: "Divers",
            question: "ACE Fund est-il présent à l’international ?",
            answer:
              "Oui, notre communauté est internationale. Les adhésions et investissements sont ouverts à tous, sous réserve de respecter les réglementations locales.",
          },
        ],
      },
      club_page: {
        hero: {
          title: "REJOIGNEZ LE CLUB D'INVESTISSEMENT ACE FUND",
          subtitle:
            "Investissez dans des projets à fort potentiel avec sécurité et transparence grâce à la tokenisation.",
          cta: "Voir les offres",
        },
        benefits: {
          title: "POURQUOI NOUS REJOINDRE ?",
          1: {
            title: "Revenus Passifs",
            desc: "Générez des revenus réguliers avec des rendements garantis.",
          },
          2: {
            title: "Best of Tech",
            desc: "La sécurité de la Blockchain pour une liquidité optimale.",
          },
          3: {
            title: "Sélection Experte",
            desc: "Nous filtrons les meilleurs projets (Cinéma, Immo, Tech) pour vous.",
          },
          4: {
            title: "Réseau Puissant",
            desc: "Investissez aux côtés de célébrités et leaders de l'industrie.",
          },
          5: {
            title: "Accès Exclusif",
            desc: "Accédez à des opportunités rares, fermées au grand public.",
          },
          6: {
            title: "Développement",
            desc: "Développez votre patrimoine et votre mindset financier.",
          },
        },
        founder: {
          title: "LE MOT DU FONDATEUR",
          name: "GREGORY MONFORT",
          role: "Serial Entrepreneur",
          quote:
            "Notre mission est de démocratiser l'investissement à fort impact. Grâce à la tokenisation, nous apportons transparence et liquidité là où il n'y en avait pas.",
        },
        pricing: {
          title: "CHOISISSEZ VOTRE ADHÉSION",
          per_year: "/ an",
          subscribe: "JE M'ABONNE",
          apply: "CANDIDATER",
          investor: {
            name: "INVESTOR",
            price: "450€",
            quote:
              "J'accède à des investissements sélectionnés et des événements dédiés",
            target: "Investisseurs · 5K–100K€ · Ouvert",
            features: [
              "Accès plateforme & dashboard",
              "Due diligence projets",
              "Newsletter mensuelle + replay des webinaires",
              "Accès aux événements des chapters",
            ],
            highlight:
              "+ événements partenaires, soit près de 1 000€ d'entrée offerts",
            note: "15% commission adhésion · Paiement trimestriel",
          },
          industry: {
            name: "INDUSTRY",
            price: "690€",
            target: "Pour les pros de l'audiovisuel",
            limit: "Limité à 100 places",
            features: [
              "Réseau audiovisuel qualifié",
              "Mises en relation ciblées",
              "Accompagnement Pitch Deck",
              "Expertise financement (Tax Shelter...)",
              "Événements exclusifs investisseurs",
              "Pass gratuits événements premium",
              "Tarif réduit plateforme tokenisation",
            ],
          },
          circle: {
            name: "BUSINESS CIRCLE",
            price: "2 000€",
            quote:
              "Je rejoins un cercle restreint d'investisseurs actifs et de dirigeants",
            target: "Investisseurs confirmés · 50K–200K€",
            features: [
              "Tout INVESTOR + accès anticipé aux deals (48h)",
              "Appels stratégiques trimestriels",
              "3 introductions business qualifiées / an",
              "Accès à l'annuaire des membres",
              "Mise en avant dans la newsletter du club",
              "Bilan annuel de la stratégie de votre société",
              "Accès prioritaire aux événements partenaires",
              "Adhésion White Rose Circle incluse",
              'Audit "Bitcoin Treasury Strategy" inclus',
            ],
            highlight: "Valeur des avantages partenaires : +5 000€/an",
            note: "25% commission adhésion · Paiement mensuel",
          },
          private: {
            name: "PRIVATE",
            price: "3 000€",
            quote:
              "J'intègre le cercle le plus exclusif d'ACE, avec un accès privilégié aux opportunités, aux événements et aux décideurs",
            target: "HNWI & Family Offices · 200K€+",
            features: [
              "Tout CIRCLE + accès anticipé étendu (72h)",
              "Appels mensuels",
              "Accès au réseau de fiscalistes, CGP et banques privées partenaires",
              "Accès tournage et festival selon disponibilités",
              "Invitation VIP sur les événements",
              "Offres off-market exclusives",
              "Accès prioritaire au réseau ACE",
              "Accès à l'investissement dans le fonds, 25% de rendement cible",
            ],
            highlight: "Valeur des avantages partenaires : +11 000€/an",
            note: "50% commission adhésion (affiliation)",
          },
        },
      },
      newsletter: {
        title: "INSCRIVEZ-VOUS A NOTRE NEWSLETTER",
        subtitle:
          "Inscrivez-vous pour recevoir les dernières actualités d'Ace Fund.",
        fields: {
          lastname: "Nom",
          firstname: "Prénom",
          email: "Adresse Email",
          language: "Langue préférée",
          is_member: "Faites-vous déjà partie du club ACE Fund ?",
          yes: "Oui",
          no: "Non",
          message: "Message (Facultatif)",
          submit: "S'INSCRIRE",
          success: "Inscription réussie ! Merci.",
          error: "Une erreur est survenue. Réessayez.",
          cta_button: "S'INSCRIRE À LA NEWSLETTER",
        },
      },
      webinar_card: {
        badge: "ÉPINGLÉ",
        title: "PROCHAIN WEBINAIRE LIVE",
        desc: "Rejoignez-nous pour découvrir les nouvelles opportunités de tokenisation exclusives.",
        date: "Bientôt disponible",
        cta: "S'INSCRIRE MAINTENANT",
      },
      exitModal: {
        title: "Ne partez pas si vite ! ",
        description:
          "Inscrivez-vous à notre newsletter pour recevoir nos meilleures opportunités d'investissement en avant-première.",
        placeholder: "Votre adresse e-mail",
        button: "S'inscrire",
        successTitle: "Merci ! 🎉",
        successMessage: "Votre inscription a bien été prise en compte.",
      },
      right_panel: {
        title: "DERNIÈRES",
        title_span: "NEWS",
        filter_btn: "Filtrer les événements",
        filter_all: "Tous les événements",
        filter_next_month: "Le mois prochain",
        filter_next_3_months: "Les 3 prochains mois",
        filter_this_year: "Cette année",
        past_events: "Événements passés",
        read_more: "Découvrir",
      },
    },
  },
  en: {
    translation: {
      nav: {
        home: "Home",
        team: "Team",
        chapter: "Chapters",
        tv: "Acefund TV",
        faq: "FAQ",
      },
      hero: {
        welcome: "Welcome to",
        subtitle_part1: "THE PLATFORM",
        subtitle_part2: "THAT TOKENIZES REVENUE-BASED FINANCING",
        q1_title: "WHAT IS REVENUE-BASED FINANCING?",
        q1_text1_start: "This model, called",
        q1_text1_span: "Revenue Based Financing",
        q1_text1_end:
          ", allows companies to get an advance on the revenue they will generate in the future.",
        q1_text2:
          "It is essentially a cash advance that unlocks non-dilutive growth capital. In exchange, financiers receive a percentage of the company's revenue over a defined period.",
        q2_title: "WHAT IS TOKENIZATION?",
        q2_text1:
          "Tokenization is the digitalization of financial securities on a blockchain ledger. Each security is digitally represented by a token.",
        q2_text2:
          "This ledger is viewable by all for greater transparency and also brings more liquidity because tokens are fungible and more easily transferable to potential buyers.",
        anim_static: "This process is",
        anim_words: ["FAST", "COST-EFFECTIVE", "IMMUTABLE"],
        anim_subtext:
          "Our technology also enables the tokenization of assets such as private equity, real estate, and ICOs.",
      },
      chapter: {
        title: "OUR CHAPTERS",
        subtitle: "Join the AceFund community near you",
      },
      rocket: {
        title_start: "DO YOU WISH TO BE",
        title_end: "SUPPORTED FOR:",
        f1_text1: "Launch an",
        f1_high1: "ICO",
        f1_text2: "or an",
        f1_high2: "STO",
        f2_text: "Fund your",
        f2_high: "project",
        f3_text: "Get a",
        f3_high: "white label solution",
        f4_text: "Create your",
        f4_high: "marketplace",
        f5_text: "Become an",
        f5_high: "investor",
        cta: "CONTACT US",
      },
      services: {
        subtitle_start: "MORE THAN A",
        subtitle_span: "SERVICE",
        card1_start: "ACE Fund is a unique",
        card1_span: "technology",
        card1_end: "and platform.",
        card2_start: "ACE Fund is an",
        card2_span: "international network",
        card2_end: "of entrepreneurs and investors.",
        card3_start: "ACE Fund is also a private and innovative investment",
        card3_span: "club",
        card3_end: ".",
      },
      cta_section: {
        button: "Join the ACE Fund Club",
      },
      testimonials_section: {
        title: "WHAT THEY SAY ABOUT US",
      },
      partners_section: {
        title: "OUR PARTNERS",
        subtitle: "PREMIUM",
      },
      group: {
        title: "The ACE Good Group",
        desc: "ACE Good develops innovative blockchain-based solutions.",
        oneticket_desc:
          "OneTicket transforms every ticket into a tamper-proof, smart, revenue-generating tool — without changing spectator habits.",
        acefund_desc:
          "ACE Fund is a solution developed by the company ACE Good.",
      },
      team_section: {
        title: "OUR",
        title_span: "TEAM",
        subtitle: "The experts behind the AceFund revolution",
        greg_desc:
          "Entrepreneur passionate about innovation, culture, and blockchain",
        alicya_desc:
          "COO of ACE Good, steering the structuring and growth of a pioneering platform for real-world asset tokenization.",
        paul_desc:
          "I combine technical expertise and product vision to build the investment tools of tomorrow.",
      },
      contact: {
        title: "CONTACT US",
        subtitle: "FOR MORE INFORMATION",
        label_name: "Last Name*",
        label_firstname: "First Name*",
        label_email: "Email*",
        label_message: "Message*",
        placeholder_name: "Your last name",
        placeholder_firstname: "Your first name",
        placeholder_email: "example@email.com",
        placeholder_message: "How can we help you?",
        btn_send: "SEND",
        btn_sending: "Sending...",
        success_title: "Message sent!",
        success_text:
          "Thank you, the AceFund team will reply to hello@acefund.io very soon.",
        btn_reset: "Send another message",
        error_alert: "An error occurred, please try again.",
      },
      faq: {
        title: "Frequently Asked Questions",
        subtitle: "Everything you need to know about the ACE Fund Club",
        search_placeholder: "Search for a question...",
        items: [
          {
            id: 1,
            category: "General",
            question: "What is the ACE Fund Club?",
            answer:
              "ACE Fund is a private investor club offering diversified investment opportunities (real estate, crypto, cinema, etc.), backed by a network of experts and exclusive events.",
          },
          {
            id: 2,
            category: "Membership",
            question: "Who can join ACE Fund? Are there admission criteria?",
            answer:
              "The club is open to any adult, whether novice or expert. No technical skills are required.",
          },
          {
            id: 3,
            category: "Benefits",
            question: "What are the benefits of being a member?",
            answer:
              "Access to exclusive opportunities, events, personalized support, sponsorship system, and VIP benefits.",
          },
          {
            id: 4,
            category: "Registration",
            question: "How to join the club?",
            answer:
              "Membership is done online via our website. Fill out the form, choose your level, and pay the fees.",
          },
          {
            id: 5,
            category: "Pricing",
            question: "What is the cost of membership?",
            answer:
              "We offer several plans (Investor, Industry, Business Circle, Private). Details are on the Membership page.",
          },
          {
            id: 8,
            category: "Operation",
            question: "How does the club select opportunities?",
            answer:
              "Our experts analyze projects (financial, legal). We prioritize innovation and high returns.",
          },
          {
            id: 11,
            category: "Operation",
            question: "Are there local chapters?",
            answer:
              "Yes (Bordeaux, Martinique, Paris...). Contact us to join or create one.",
          },
          {
            id: 19,
            category: "Sponsorship",
            question: "How does sponsorship work?",
            answer:
              "You earn a commission on every membership made via your unique link: 15% on Investor, 25% on Business Circle and 50% on Private.",
          },
          {
            id: 22,
            category: "Investment",
            question: "What types of opportunities do you offer?",
            answer:
              "Real estate, cinema, crypto, and other innovative sectors.",
          },
          {
            id: 32,
            category: "Blockchain",
            question: "What is blockchain?",
            answer:
              "A transparent and secure storage technology allowing tamper-proof transactions.",
          },
          {
            id: 37,
            category: "Tokenization",
            question: "What is tokenization?",
            answer:
              "Dividing an asset into digital tokens to allow fractional investment.",
          },
          {
            id: 38,
            category: "Tokenization",
            question: "What are the advantages of tokenization?",
            answer:
              "Investment is fractional and accessible, liquidity is accumulated (resale possible), and transaction traceability is complete.",
          },
          {
            id: 39,
            category: "Tokenization",
            question: "How do I buy, sell, or exchange tokens?",
            answer:
              "Tokens can be bought through our platform or partner exchanges. To sell them, you can list them on our marketplace or exchange them for other tokens.",
          },
          {
            id: 40,
            category: "Tokenization",
            question: "Where are my tokens stored? Do I need a wallet?",
            answer:
              "No, you will have a wallet automatically created from your email address. It will be stored on the blockchain and accessible from our ACE Fund platform.",
          },
          {
            id: 41,
            category: "Tokenization",
            question: "What is a smart contract?",
            answer:
              "A smart contract is an automated program that executes the terms of a contract (e.g., dividend payments) without an intermediary. It is stored on the blockchain and cannot be modified.",
          },
          {
            id: 42,
            category: "Tokenization",
            question: "Is tokenization regulated?",
            answer:
              "Yes, tokenized projects must comply with applicable regulations (AMF in France, SEC in the USA). We work with specialized lawyers to ensure compliance.",
          },
          {
            id: 43,
            category: "Risks",
            question:
              "What are the risks associated with tokenized investments?",
            answer:
              "The risks are the same as for traditional investments. Our security thesis complies with the cybersecurity requirements mandated by the French government.",
          },
          {
            id: 44,
            category: "Risks",
            question: "How do you guarantee transparency?",
            answer:
              "All projects are audited, and transactions are recorded on the blockchain, accessible to everyone. We also publish regular reports.",
          },
          {
            id: 45,
            category: "Risks",
            question: "Can I lose my entire investment?",
            answer:
              "Like any investment, there is a risk of loss. We select solid projects, but we always recommend diversifying your investments.",
          },
          {
            id: 46,
            category: "Technical",
            question: "How can I pay for and exchange my tokens?",
            answer:
              "You log in to the platform and easily exchange your tokens. Your wallet is directly linked to your email account.",
          },
          {
            id: 47,
            category: "Miscellaneous",
            question: "Is ACE Fund present internationally?",
            answer:
              "Yes, our community is international. Memberships and investments are open to everyone, subject to compliance with local regulations.",
          },
        ],
      },
      club_page: {
        hero: {
          title: "JOIN THE ACE FUND INVESTMENT CLUB",
          subtitle:
            "Invest in high-potential projects with security and transparency through tokenization.",
          cta: "View Offers",
        },
        benefits: {
          title: "WHY JOIN US?",
          1: {
            title: "Passive Income",
            desc: "Generate regular income with guaranteed returns.",
          },
          2: {
            title: "Best of Tech",
            desc: "Blockchain security for optimal liquidity.",
          },
          3: {
            title: "Expert Selection",
            desc: "We filter the best projects (Cinema, Real Estate, Tech) for you.",
          },
          4: {
            title: "Powerful Network",
            desc: "Invest alongside celebrities and industry leaders.",
          },
          5: {
            title: "Exclusive Access",
            desc: "Access rare opportunities closed to the general public.",
          },
          6: {
            title: "Development",
            desc: "Grow your wealth and your financial mindset.",
          },
        },
        founder: {
          title: "WORD FROM THE FOUNDER",
          name: "GREGORY MONFORT",
          role: "Serial Entrepreneur",
          quote:
            "Our mission is to democratize high-impact investment. Through tokenization, we bring transparency and liquidity where there was none.",
        },
        pricing: {
          title: "CHOOSE YOUR MEMBERSHIP",
          per_year: "/ year",
          subscribe: "SUBSCRIBE",
          apply: "APPLY NOW",
          investor: {
            name: "INVESTOR",
            price: "450€",
            quote:
              "I get access to selected investments and dedicated events",
            target: "Investors · 5K–100K€ · Open",
            features: [
              "Platform & dashboard access",
              "Project due diligence",
              "Monthly newsletter + webinar replays",
              "Access to chapter events",
            ],
            highlight:
              "+ partner events, worth nearly €1,000 of free entry",
            note: "15% membership commission · Quarterly payment",
          },
          industry: {
            name: "INDUSTRY",
            price: "690€",
            target: "For audiovisual professionals",
            limit: "Only 100 places",
            features: [
              "Qualified audiovisual network",
              "Targeted strategic introductions",
              "Pitch deck structuring support",
              "Financing expertise (Tax Shelter...)",
              "Exclusive investor events",
              "Free premium event passes",
              "Tokenization platform discount",
            ],
          },
          circle: {
            name: "BUSINESS CIRCLE",
            price: "2,000€",
            quote:
              "I join a select circle of active investors and business leaders",
            target: "Seasoned investors · 50K–200K€",
            features: [
              "Everything in INVESTOR + early deal access (48h)",
              "Quarterly strategy calls",
              "3 qualified business introductions / year",
              "Access to the members directory",
              "Featured in the club newsletter",
              "Annual strategy review for your company",
              "Priority access to partner events",
              "White Rose Circle membership included",
              'Included "Bitcoin Treasury Strategy" audit',
            ],
            highlight: "Partner benefits value: +€5,000/year",
            note: "25% membership commission · Monthly payment",
          },
          private: {
            name: "PRIVATE",
            price: "3,000€",
            quote:
              "I join ACE's most exclusive circle, with privileged access to opportunities, events and decision-makers",
            target: "HNWI & Family Offices · 200K€+",
            features: [
              "Everything in CIRCLE + extended early access (72h)",
              "Monthly calls",
              "Access to partner tax advisors, wealth managers and private banks",
              "Access to filming and festival, subject to availability",
              "VIP invitation to events",
              "Exclusive off-market offers",
              "Priority access to the ACE network",
              "Access to fund investment, 25% target return",
            ],
            highlight: "Partner benefits value: +€11,000/year",
            note: "50% membership commission (affiliation)",
          },
        },
      },
      newsletter: {
        title: "SUBSCRIBE TO OUR NEWSLETTER",
        subtitle: "Sign up to receive the latest news from Ace Fund.",
        fields: {
          lastname: "Lastname",
          firstname: "Firstname",
          email: "Email adress",
          language: "your language",
          is_member: "Are you already a member of the ACE Fund club?",
          yes: "Yes",
          no: "No",
          message: "Message (Facultatif)",
          submit: "SUBSCRIBE",
          success: "Registration successful! Thank you.",
          error: "An error has occurred. Please try again.",
          cta_button: "SUBSCRIBE TO NEWSLETTER",
        },
      },
      webinar_card: {
        badge: "PINNED",
        title: "NEXT LIVE WEBINAR",
        desc: "Join us to discover exclusive new tokenization opportunities.",
        date: "Coming soon",
        cta: "REGISTER NOW",
      },
      exitModal: {
        title: "Don't leave so soon! ",
        description:
          "Subscribe to our newsletter to receive our best investment opportunities in preview.",
        placeholder: "Your email address",
        button: "Subscribe",
        successTitle: "Thank you! 🎉",
        successMessage: "Your subscription has been successfully registered.",
      },
      right_panel: {
        title: "LATEST",
        title_span: "NEWS",
        filter_btn: "Filter events",
        filter_all: "All events",
        filter_next_month: "Next month",
        filter_next_3_months: "Next 3 months",
        filter_this_year: "This year",
        past_events: "Past events",
        read_more: "Discover",
      },
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: "fr",
    fallbackLng: "fr",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
